import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // previously cacheTime
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Helper function for fetch with cache
export async function fetchWithCache<T>(
  key: string[],
  fetcher: () => Promise<T>
): Promise<T> {
  return queryClient.fetchQuery({ queryKey: key, queryFn: fetcher });
}
